/**
 * Analytics Utilities
 * 분석 유틸리티
 */

export function trackEvent(category: string, action: string, label?: string, value?: number) {
  if (import.meta.env.DEV) {
    console.log('Analytics:', { category, action, label, value })
  }

  // 실제로는 Google Analytics, Mixpanel 등 사용
  // gtag('event', action, { event_category: category, event_label: label, value })
}

export function trackPageView(path: string) {
  try {
    trackEvent('Navigation', 'Page View', path)
  } catch (error) {
    // Analytics 오류는 앱 실행을 방해하지 않음
    if (import.meta.env.DEV) {
      console.warn('Analytics error:', error)
    }
  }
}

export function trackError(error: Error, context?: string) {
  trackEvent('Error', 'Error Occurred', context || error.message)
}

export function trackAPICall(endpoint: string, success: boolean, duration?: number) {
  trackEvent('API', success ? 'Success' : 'Failure', endpoint, duration)
}

